/**
 * Site-wide constants. CommonJS so the build scripts can read them too.
 *
 * SITE_URL is the ONE canonical origin: every canonical tag, OG url, sitemap
 * entry and JSON-LD @id is built from it, and vercel.json 301s the apex host
 * here so the two hostnames stop competing for the same keywords.
 */

const SITE_URL = "https://www.bagadsattacompany.com";
const SITE_NAME = "Bagad Satta Company";
const APP_URL = "https://app.bagadsattaking.com/apk";
const CONTACT_EMAIL = "support@bagadsattacompany.com";

/** Every crawlable route, in sitemap priority order. */
const STATIC_ROUTES = [
  { path: "/", priority: "1.0", changefreq: "hourly" },
  { path: "/satta-chart", priority: "0.9", changefreq: "daily" },
  { path: "/faq", priority: "0.7", changefreq: "monthly" },
  { path: "/about-us", priority: "0.5", changefreq: "monthly" },
  { path: "/contact-us", priority: "0.5", changefreq: "monthly" },
  { path: "/disclaimer", priority: "0.4", changefreq: "yearly" },
  { path: "/privacy-policy", priority: "0.3", changefreq: "yearly" },
  { path: "/terms-and-conditions", priority: "0.3", changefreq: "yearly" },
];

function absoluteUrl(path) {
  if (!path || path === "/") return SITE_URL + "/";
  return SITE_URL + (path.startsWith("/") ? path : "/" + path);
}

module.exports = {
  SITE_URL,
  SITE_NAME,
  APP_URL,
  CONTACT_EMAIL,
  STATIC_ROUTES,
  absoluteUrl,
};
